<template>
 <div class="additional"
      :class="{
        'additional__benefit': type === 'benefit',
        'additional__installment-payment': type === 'installmentPayment',
      }"
      @mouseenter="showAdditionalModal = true"
      @mouseleave="showAdditionalModal = false"
 >
   <div class="svg">
     <svg v-if="type === 'benefit'" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M11 5.5C9.01175 5.5 7.39383 7.11792 7.39383 9.10617H9.22716C9.22716 8.12808 10.0228 7.33333 11 7.33333C11.9772 7.33333 12.7728 8.12808 12.7728 9.10617C12.7728 9.65433 12.3319 10.0522 11.6582 10.5967C11.4244 10.7864 11.2035 10.967 11.0247 11.1458C10.1099 12.0597 10.0833 13.0304 10.0833 13.1386V13.75H11.9167L11.9157 13.1697C11.9167 13.1551 11.946 12.8159 12.32 12.4428C12.4575 12.3053 12.6307 12.1678 12.8104 12.023C13.5245 11.4446 14.6052 10.571 14.6052 9.10617C14.6062 7.11792 12.9882 5.5 11 5.5ZM10.0833 14.6667H11.9167V16.5H10.0833V14.6667Z" fill="#B1A1F2"/>
       <path d="M11 1.83301C5.94551 1.83301 1.83334 5.94517 1.83334 10.9997C1.83334 16.0542 5.94551 20.1663 11 20.1663C16.0545 20.1663 20.1667 16.0542 20.1667 10.9997C20.1667 5.94517 16.0545 1.83301 11 1.83301ZM11 18.333C6.95659 18.333 3.66668 15.0431 3.66668 10.9997C3.66668 6.95626 6.95659 3.66634 11 3.66634C15.0434 3.66634 18.3333 6.95626 18.3333 10.9997C18.3333 15.0431 15.0434 18.333 11 18.333Z" fill="#B1A1F2"/>
     </svg>

     <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z" fill="#B1A1F2"/>
       <circle cx="9" cy="9" r="1.5" fill="#B1A1F2"/>
       <circle cx="15" cy="15" r="1.5" fill="#B1A1F2"/>
       <rect x="15.5355" y="7.05078" width="2" height="12" rx="1" transform="rotate(45 15.5355 7.05078)" fill="#B1A1F2"/>
     </svg>
   </div>

   <transition name="fadeFast">
     <div class="additional_modal"
          v-if="showAdditionalModal"
     >
      {{ text }}
     </div>
   </transition>
 </div>
</template>

<script>
export default {
  name: "BlockAdditional",

  props: {
    type: { // тип блока / benefit - пояснение выгоды / installmentPayment - доступна рассрочка
      type: String,
      default: () => {
        return 'benefit'
      }
    },

    text: { // текст блока
      type: String,
      default: () => {
        return ''
      }
    },
  },

  data() {
    return {
      showAdditionalModal: false, // отобразить модальное окно пояснения
    }
  },

  created() {

  },

  mounted() {

  },

  watch: {

  },

  methods: {

  },

  computed: {

  },

  components: {

  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

.additional {
  display: flex;
  flex-direction: row;
  position: relative;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.additional_modal {
  display: flex;
  flex-direction: row;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 8px;
  padding: 14px;
  z-index: 5;
  cursor: default;
  width: 318px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  position: absolute;
  right: 0;
  top: 0;
}

@media all and (max-width: 1600px) {

}

@media all and (max-width: 1440px) {
  .additional__benefit .svg svg {
    width: 20px;
    height: auto;
  }

  .additional__installment-payment .svg svg {
    width: 22px;
    height: auto;
  }

  .additional_modal {
    width: 300px;
    font-size: 15px;
    line-height: 19px;
  }
}

@media all and (max-width: 1280px) {

}

// tablet
@media all and (max-width: 1160px) {

}

@media all and (max-width: 960px) {

}

// mobile
@media all and (max-width: 600px) {
  .additional_modal {
    width: 264px;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>